import type { ChatMessage, ChatMessageContent } from '@footsteps/shared';

/**
 * Entity wrapping a single item in the jsonb `messages` array.
 * Transient UI-only properties (`removing`, `canRevert`) are stripped
 * on serialisation and rehydrated at runtime.
 */
export class WozCaseMessageEntity {
  id: string;
  role: ChatMessage['role'];
  content: ChatMessageContent;
  createdAt: string;

  constructor(data: Partial<ChatMessage> = {}) {
    this.id = data.id ?? '';
    this.role = data.role ?? 'assistant';
    this.content = data.content ?? ({ type: 'text', text: '' } as ChatMessageContent);
    this.createdAt = data.createdAt ?? new Date().toISOString();
  }

  /** Convert to a ChatMessage without transient props. */
  toJSON(): ChatMessage {
    return {
      id: this.id,
      role: this.role,
      content: this.content,
      createdAt: this.createdAt,
    };
  }

  /** Create from a ChatMessage, stripping transient props. */
  static fromChatMessage(msg: ChatMessage): WozCaseMessageEntity {
    return new WozCaseMessageEntity({
      id: msg.id,
      role: msg.role,
      content: msg.content,
      createdAt: msg.createdAt,
    });
  }
}
